import { IGetIsOfferOptions } from './types';

export const getIsOffer = ({ selectedOfferCartEntry, item }: IGetIsOfferOptions) =>
  selectedOfferCartEntry && selectedOfferCartEntry.sanityId === item.sanityId;
